import { useState } from "react";
import { ShareNetwork, EnvelopeSimple, ChatText, WhatsappLogo, XLogo, LinkSimple, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

async function safeCopy(url) {
  try {
    await navigator.clipboard.writeText(url);
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = url; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); document.body.removeChild(ta);
    } catch { /* ignore */ }
  }
}

function ShareBtn({ testid, icon: Icon, label, href, onClick }) {
  const cls = "flex flex-col items-center justify-center gap-1 min-w-[64px] px-3 py-2.5 rounded-lg border border-[#E9DDC6] bg-white text-[#4A0000] hover:border-[#4A0000] hover:-translate-y-0.5 transition-all";
  const inner = <><Icon size={18} weight="duotone" /><span className="text-xs">{label}</span></>;
  return href
    ? <a data-testid={testid} href={href} target="_blank" rel="noreferrer" className={cls}>{inner}</a>
    : <button data-testid={testid} type="button" onClick={onClick} className={cls}>{inner}</button>;
}

export default function ShareRow({ url, title = "Book a shoot with me" }) {
  const [copied, setCopied] = useState(false);
  if (!url) return null;
  const enc = encodeURIComponent;
  const msg = `${title}: ${url}`;
  const canNativeShare = typeof navigator !== "undefined" && !!navigator.share;

  const nativeShare = async () => {
    try { await navigator.share({ title, text: title, url }); } catch { /* user dismissed */ }
  };
  const copy = async () => {
    await safeCopy(url);
    setCopied(true); setTimeout(() => setCopied(false), 1800);
    toast.success("Link copied");
  };

  return (
    <div data-testid="share-row">
      <p className="text-xs uppercase tracking-widest text-[#5C5A58] mb-2">Share via</p>
      <div className="flex flex-wrap gap-2">
        {canNativeShare && <ShareBtn testid="share-native" icon={ShareNetwork} label="Share" onClick={nativeShare} />}
        <ShareBtn testid="share-email" icon={EnvelopeSimple} label="Email" href={`mailto:?subject=${enc(title)}&body=${enc(msg)}`} />
        <ShareBtn testid="share-sms" icon={ChatText} label="Text" href={`sms:?&body=${enc(msg)}`} />
        <ShareBtn testid="share-whatsapp" icon={WhatsappLogo} label="WhatsApp" href={`https://wa.me/?text=${enc(msg)}`} />
        <ShareBtn testid="share-x" icon={XLogo} label="Post" href={`https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(url)}`} />
        <ShareBtn testid="share-copy" icon={copied ? Check : LinkSimple} label={copied ? "Copied" : "Copy"} onClick={copy} />
      </div>
    </div>
  );
}
